// const CryptoJS = require('crypto-js');
import * as CryptoJS from 'crypto-js';
// const keyFile = require('KeyFile.pem');

// var KeyValue = fetch(keyFile)
//   .then(r => r.text())
//   .then(text => {
//     return text;
//   });

export const Encrypt = function (data) {
  const ciphertext = CryptoJS.AES.encrypt(
    JSON.stringify(data),
    'my-secret-key@6fa979f20126cb08aa645a8f495f6d85'
  ).toString();
  return ciphertext;
};

export const Decrypt = function (data) {
  const bytes = CryptoJS.AES.decrypt(data, 'my-secret-key@6fa979f20126cb08aa645a8f495f6d85');
  const decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
  return decryptedData;
};

// export const Encrypt = async data => {
//   var key = await (await KeyValue).toString();
//   var ciphertext = CryptoJS.AES.encrypt(JSON.stringify(data), key).toString();
//   return ciphertext;
// };

// export const Decrypt = async data => {
//   var key = await (await KeyValue).toString();
//   var bytes = CryptoJS.AES.decrypt(data, key);
//   var decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
//   return decryptedData;
// };
